module.exports = __webpack_public_path__ + "img/qrcode.b876a900.jpg";